import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import InstanceRow from "./adminViewBatchRow";
import { FrontendContentPage } from "node-library/dist/constants";
import AdminViewInstanceRow from "./adminViewBatchRow";
import { FrontendSampleTestBatchOverview } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import AdminViewBatchRow from "./adminViewBatchRow";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	batchOverviews: Array<FrontendSampleTestBatchOverview>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;

	navigateToOrderDetailsPage: (
		orderId: string,
		fromPage: FrontendContentPage
	) => void;
	navigateToBatchDetailsPage: (
		batchId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AdminViewBatchTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		batchOverviews,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		user,
		navigateToOrderDetailsPage,
		navigateToBatchDetailsPage,
	} = props;

	const headerItems = [
		{
			title: translation("Batches"),
		},
		{
			title: translation("Test"),
		},
		{
			title: translation("MethodId"),
		},
		{
			title: translation("Size"),
		},
		{
			title: translation("CreatedBy"),
		},
		{
			title: translation("DueDate"),
		},
		{
			title: translation("Status"),
		},
		{
			title: translation("Action"),
		},
	];

	const batchRows: Array<React.ReactNode> = batchOverviews
		? batchOverviews.map(
				(batchOverview: FrontendSampleTestBatchOverview, index: number) => {
					return (
						<AdminViewBatchRow
							company={company}
							key={batchOverview.testBatchId}
							batchOverview={batchOverview}
							user={props.user}
							deleteBatch={() => {
								console.log("You clicked me!!");
							}}
							goToViewBatchDetails={() => {
								navigateToBatchDetailsPage(
									batchOverview.testBatchId,
									FrontendContentPage.BATCH_PAGE
								);
							}}
						/>
					);
				}
		  )
		: [];

	const headerRowItems: React.ReactNode = headerItems.map((item) => {
		return (
			<div key={item.title} style={{ display: "flex", gap: "10px" }}>
				<Divider orientation="vertical" flexItem></Divider>
				<div
					className="typography-body-01"
					style={{
						color: NeutralColor.NEUTRAL_GREY_500,
						display: "flex",
						alignItems: "center",
						gap: "5px",
					}}
				>
					{item.title}
					{/* {item.sortColumnBy && (
						<SortArrowIcon
							sortOrder={sortOrder}
							notInUse={sortBy !== item.sortColumnBy}
						/>
					)} */}
				</div>
			</div>
		);
	});

	const batchRowContainer: React.ReactNode = (
		<Card className="common-card card-medium-padding">{batchRows}</Card>
	);

	return (
		<div>
			<div className="batch-list-view-row batch-list-view-header">
				{headerRowItems}
			</div>
			{batchRowContainer}
		</div>
	);
}
